import { render, staticRenderFns } from "./more_information.vue?vue&type=template&id=76898de2&scoped=true&"
import script from "./more_information.vue?vue&type=script&lang=js&"
export * from "./more_information.vue?vue&type=script&lang=js&"
import style0 from "./more_information.vue?vue&type=style&index=0&id=76898de2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76898de2",
  null
  
)

export default component.exports